/**
 * @author Eric Otto
 */

module.exports = {
    counter: 1,
    limit: 5,
    link: document.querySelector('#load-more-ajax'),

    init: function ($container) {
        'use strict';

        this.link = $container
            ? $container.querySelector('#load-more-ajax')
            : document.querySelector('#load-more-ajax');


        if (!this.link) {
            return;
        }

        this.resetCounter();

        const that = this,
            container = document.getElementById('load-more-content'),
            wrapper = document.querySelector('.mdl-layout__content'),
            retinaImages = require('./retinaImages'),
            ajaxLoad = require('./ajaxLoad'),
            loadFilter = require('./loadFilter'),
            r = new XMLHttpRequest();

        let height = window.innerHeight - 96;

        wrapper.onscroll = function () {
            let scrollPosition = wrapper.scrollTop + height;

            if (that.link &&
                !that.link.classList.contains('active') &&
                !that.link.classList.contains('empty') &&
                that.link.offsetTop <= scrollPosition
            ) {
                that.link.classList.add('active');

                r.onreadystatechange = function () {
                    if (r.readyState !== 4 || r.status !== 200) {
                        return;
                    }

                    if (r.responseText.length > 1) {

                        const fakeContainer = document.createElement('div');
                        let intTime = 0;
                        fakeContainer.innerHTML = r.responseText;

                        retinaImages.init(fakeContainer);
                        ajaxLoad.init(fakeContainer);

                        const elements = fakeContainer.querySelectorAll('div');

                        for (let i = 0; i < elements.length; i++) {
                            container.appendChild(elements[i]);
                            window.setTimeout(function () {
                                if (elements[i].classList.contains('is-paused')) {
                                    elements[i].classList.remove('is-paused');
                                }
                            }, intTime);
                            intTime += 250;
                        }


                    } else {
                        that.link.classList.add('empty');
                    }

                    that.link.classList.remove('active');
                };

                const formData = loadFilter.getFormData();

                formData.append('tx_eowagencyqx_projects[offset]', that.counter * that.limit);

                r.open('POST', that.link.getAttribute('data-uri'), true);
                r.send(formData);

                that.counter += 1;
            }
        };
    },

    resetCounter: function () {
        'use strict';

        this.counter = 1;
        this.link.classList.remove('empty');
    }
};
